import React, { Component } from 'react';
import './HomeQuotes.scss';
import Carousel from '../../../components/Carousel'

class HomeQuotes extends Component {

    constructor(props) {
        super(props);
        this.state = {}
    };

    render() {
        const quotes = this.props.quotes.map((item, index) => {
          return (
            <div className="">
            <div className="text-center quote-thing">
              <p>"{item.quote}"</p>
              <h4>{item.name}</h4>
              <p>{item.role}</p>
</div>

            </div>
          )
        })
        return (
            <div className='home-quotes'>

              <div className="container  section_padding_100">
                <div className='text-center'>
                  <h2>What People Are Saying</h2>
                </div>
                <div className="line-shape"></div>
                <Carousel settings={{dots: true, centerPadding: '20px', centerMode: true, infinite: true, arrows: false, speed: 500, slidesToShow: 1, slidesToScroll: 1}}>
                    {quotes}
                </Carousel>
              </div>


            </div>
        )
    }
}

export default HomeQuotes;



// WEBPACK FOOTER //
// ./src/views/pages/Home2/HomeQuotes/index.js